import { useQuery } from "@apollo/client";
import { PERSON_BY_ID_QUERY } from "../../../../../api/person/queries";
import { personKorrespondanceForm } from "../../../../../config/form/person/personKorrespondanceFormConfig";
import { defaultPersonKorrespondanceColumns } from "../../../../../config/person";
import { getHeaderActiveColumns, TD } from "../../../../../util/table";
import { tableToXLSX } from "../../../../../util/tableExportUtils";
import ButtonDownload from "../../../../ButtonDownload";
import OpenEmailIcon from "../../../../icons/OpenEmailIcon";
import TableBasic, { TableRow } from "../../../../Table/TableBasic";
import DocumentModal from "../../../../Modal/modals/DocumentModal";
import IngenRegistreringer from "../IngenRegistreringer";
import {
  PersonDto,
  PersonKorrespondance,
} from "../../../../../interfaces/schema";
import { PersonKorrespondanceField } from "../../../../../interfaces/personer";
import { IColumn, SortBy } from "../../../../../interfaces/table";
import useLocalStorageState from "use-local-storage-state";
import { useContext } from "react";
import { UserQueryContext } from "../../../../../context/UserContext";
import { orderBy } from "../../../../../util/orderBy";

export default function Korrespondence({
  columns,
  invalidateData,
  personId,
  personKorrespondance,
  setActiveColumns,
}: {
  personId: string;
  invalidateData: InvalidateDataFunction<any>;
  personKorrespondance: PersonKorrespondance[];
  columns: IColumn<PersonKorrespondanceField>[];
  setActiveColumns: React.Dispatch<
    React.SetStateAction<PersonKorrespondanceField[]>
  >;
}) {
  const { user, hasPermission } = useContext(UserQueryContext);
  const canWrite = hasPermission(user, "BasisWrite");
  const [sortBy, setSortBy] = useLocalStorageState<SortBy[]>(
    "personKorrespondenceSortBy",
    {
      defaultValue: defaultSortBy,
    },
  );

  const { data } = useQuery<{
    person: PersonDto;
  }>(PERSON_BY_ID_QUERY(), {
    variables: { id: personId },
  });

  // event handlers
  function downloadHandler() {
    tableToXLSX(columns, personKorrespondance, {
      fileName: `korrespondance-for-${data?.person.kundeNr}`,
      additionalData: {
        kundenr: data?.person.kundeNr,
      },
    });
  }

  if (!personKorrespondance.length) return <IngenRegistreringer />;
  return (
    <>
      <ButtonDownload onClick={downloadHandler} />
      <TableBasic
        defaultColumns={defaultPersonKorrespondanceColumns}
        columns={columns}
        setActiveColumns={setActiveColumns}
        headerRow={
          <>
            {getHeaderActiveColumns(columns, {
              defaultSortBy,
              setSortBy,
              sortBy,
            })}
            <th>&nbsp;</th>
          </>
        }
      >
        {orderBy(
          personKorrespondance,
          sortBy.map((ds) => ds.field),
          sortBy.map((ds) => ds.direction),
        ).map((kor) => {
          const editConfig = personKorrespondanceForm(personId, kor.id);
          return (
            <TableRow
              key={kor.id}
              editConfig={canWrite ? editConfig : undefined}
              invalidateData={invalidateData}
            >
              <>
                {columns
                  .filter((col) => col.active)
                  .map((col) => {
                    return <TD key={col.field} col={col} rowData={kor} />;
                  })}
              </>
              <td>
                {editConfig.getDocument && (
                  <DocumentModal
                    getDocument={editConfig.getDocument}
                    downloadLink={editConfig.downloadLink}
                    title={
                      <>
                        <OpenEmailIcon height={18} />
                        <span className="h3">
                          {kor.beskrivelse}
                          {/* <small className="text-secondary">
                          {kor.opretDato}
                        </small> */}
                        </span>
                      </>
                    }
                    buttonContents={[
                      <OpenEmailIcon key={1} />,
                      <span key={2}>Vis</span>,
                    ]}
                    contentProps={{
                      className: "c-document c-document--korrespondence",
                    }}
                  />
                )}
              </td>
            </TableRow>
          );
        })}
      </TableBasic>
    </>
  );
}
const defaultSortBy: SortBy[] = [
  {
    direction: "desc",
    field: "opretDato",
  },
];
